import { createSelector } from '@ngrx/store';
import { getIsCrewOnMultiTransactionFlow } from '@store/reducers/multi-account/multi-account.reducer';

import * as fromFeature from '../../reducers';

export const selectMultiAccountState = createSelector(
  fromFeature.getMultiAccountState,
  (state) => state,
);

export const selectIsCrewOnMultiInheritanceFlow = createSelector(
  selectMultiAccountState,
  getIsCrewOnMultiTransactionFlow,
);
